export default "__VITE_ASSET__6DRbmWfD__"